import ZiniHubCustUXWizard from "./ZiniHubCustUXWizard";

export default ZiniHubCustUXWizard;
